/* eslint-disable no-multi-str */
/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useState, useContext, useEffect } from 'react';
import { Editor } from '@tinymce/tinymce-react';
import Input from './common/Input';
import { Badge, Form } from 'react-bootstrap';
import { CoreContext } from '../context/core-context';
import { AuthContext } from '../context/auth-context';
import { useForm } from "react-hook-form";


const AddPage = (props) => {

    const coreContext = useContext(CoreContext);
    const authContext = useContext(AuthContext);
    const [title, setTitle] = useState('');
    const [slug, setSlug] = useState('');
    const [message, setMessage] = useState('');
    const [metaKeyWord, setMetaKeyWord] = useState('');
    const [metaDescription, setMetaDescription] = useState('');
    const [content, setContent] = useState('Enter Page Content...');
    const [menu, setMenu] = useState('');

    const fetchMenu = () => {
        coreContext.fetchMenu(authContext.itemId);
    }

    useEffect(fetchMenu, []);

    const { register, handleSubmit, formState: { errors } } = useForm();



    const handleEditorChange = (content, editor) => {
        setContent(content);
    }

    const onPageContentHandler = (data) => {
        const { title, message, slug, menu, mkword, mkdescription } = data;
        coreContext.addPageContent(title, message, content, slug, menu, authContext.itemId, authContext.userId, mkword, mkdescription);

    }


    return (<div className='container-fluid'>
        <div className="card">
            <div className="card-title mx-auto"><h3><Badge variant="success">Add New Page</Badge></h3></div>
            <div className="card-body">

                <Form autoComplete='off' onSubmit={handleSubmit(onPageContentHandler)} noValidate>

                    <Input label='Menu' name='menu' required={true} register={register} errors={errors} elementType='select' value={menu} options={coreContext.menu} />
                    <div className="row"><div className="col-md-3">
                        <Input label='Title' value={title} name='title' minLength={2} maxLength={155} required={true} register={register} errors={errors} elementType='textarea' placeholder='Enter Title' /></div>
                        <div className="col-md-4">
                            <Input label='Meta Key Word' value={metaKeyWord} name='mkword' minLength={2} maxLength={555} required={false} register={register} errors={errors} elementType='textarea' placeholder='Enter Meta Key Word' /> </div>
                        <div className="col-md-5">
                            <Input label='Meta Description' value={metaDescription} name='mkdescription' minLength={2} maxLength={555} required={false} register={register} errors={errors} elementType='textarea' placeholder='Enter Meta Description' /> </div>
                    </div>

                    <Input label='Slug' value={slug} name='slug' minLength={2} maxLength={155} required={true} register={register} errors={errors} elementType='text' placeholder='Enter Slug' />

                    <Input label='Message' value={message} name='message' minLength={2} maxLength={2000} required={false} register={register} errors={errors} elementType='textarea' placeholder='Enter Message' />


                    <Form.Group>
                        <Editor
                            apiKey={coreContext.key}
                            value={content}
                            init={{
                                height: 500,
                                menubar: 'insert',
                                file_picker_types: 'file image media',
                                plugins: [
                                    'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
                                    'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                                    'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount'
                                ],
                                toolbar:
                                    'undo redo | formatselect | bold italic backcolor forecolor  | fontsize fontfamily lineheight | \
             alignleft aligncenter alignright alignjustify | \
             bullist numlist outdent indent image | removeformat | code | help'
                            }}
                            onEditorChange={handleEditorChange}
                        />
                    </Form.Group>
                    <Input elementType='button' variant='primary' value="Update" /> &nbsp;&nbsp; {coreContext.renderLoader()}
                    <Input variant='danger' label={coreContext.message} elementType='label' />
                </Form>
            </div>
        </div>
    </div>
    )
}

export { AddPage }